import React, { useEffect, useRef } from "react";

import {
  INLINE_POSITION_INSIGHT_HEADING_ID,
  INLINE_POSITION_INSIGHT_ID,
  inspectButtonIdOf,
} from "../../constants";
import { buildHoldingDisplay } from "../Holdings/holdingDisplay";
import { ButtonTypes } from "../../../../../components/Button";
import { MetricGrid } from "./MetricGrid";
import { positionMetrics } from "./positionMetrics";
import { InlinePositionInsightProps } from "./types";
import {
  HeaderText,
  HeadingNote,
  InlineHeader,
  InlineHeading,
  InlinePanel,
  Note,
  ResetButton,
} from "./styles";

const ALLOCATION_WITHHELD_NOTE =
  "Portfolio allocation is withheld until every open position has a price.";

export const InlinePositionInsight: React.FC<InlinePositionInsightProps> = ({
  holding,
  onClearSelection,
}) => {
  const panelRef = useRef<HTMLElement>(null);

  // A card at the bottom of the screen would otherwise open its panel below the fold.
  useEffect(() => {
    panelRef.current?.scrollIntoView?.({ block: "nearest" });
  }, [holding.id]);

  const close = () => {
    onClearSelection();
    // Clearing unmounts this panel, so focus would otherwise fall back to <body>.
    document.getElementById(inspectButtonIdOf(holding.id))?.focus();
  };

  const metrics = [
    { label: "Broker value", value: buildHoldingDisplay(holding).valueText },
    ...positionMetrics(holding),
  ];

  return (
    <InlinePanel
      as="section"
      ref={panelRef}
      id={INLINE_POSITION_INSIGHT_ID}
      aria-labelledby={INLINE_POSITION_INSIGHT_HEADING_ID}
    >
      <InlineHeader>
        <HeaderText>
          <InlineHeading id={INLINE_POSITION_INSIGHT_HEADING_ID}>
            {holding.instrument.symbol} position insight
          </InlineHeading>
          <HeadingNote>{holding.instrument.name}</HeadingNote>
        </HeaderText>
        <ResetButton type={ButtonTypes.primary} size="small" onClick={close}>
          Close
        </ResetButton>
      </InlineHeader>
      <MetricGrid metrics={metrics} />
      {holding.allocationPercent === null && (
        <Note>{ALLOCATION_WITHHELD_NOTE}</Note>
      )}
    </InlinePanel>
  );
};
